<template>
  <div>
    <div class="accordion" role="tablist" v-if="project && project.serviceReport">
      <div>
        <h1>1. {{ $t('brickAndUk') }}</h1>
        <BrickAndSubstructure :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>2. {{ $t('solarPanels') }}</h1>
        <SolarPanels :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>3. {{ $t('cableManagement') }}</h1>
        <CableManagement :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>4. {{ $t('hak') }}</h1>
        <HAK :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>5. {{ $t('zs') }}</h1>
        <ElectricMeter :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>6. {{ $t('electric_meter') }}</h1>
        <Inverter :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>7. {{ $t('locationAndCable') }}</h1>
        <InstallationLocation :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>8. {{ $t('earthingUnit') }}</h1>
        <EarthingUnit :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>9. {{ $t('internetConnection') }}</h1>
        <InternetAccess :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>10. {{ $t('wallbox') }}</h1>
        <Wallbox :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
      <div>
        <h1>11. {{ $t('MISC') }}</h1>
        <Misc :cards="cards" :project="project" :referenceData="referenceData" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { toServiceCardInput } from '@/blocks/project/projectServiceReportDataInput';
import { ReportCardsMixin } from '@/mixins/reportCards';
import BrickAndSubstructure from './MobileService/BrickAndSubstructure.vue';
import SolarPanels from './MobileService/SolarPanels.vue';
import Misc from './MobileService/Misc.vue';
import EarthingUnit from './MobileService/EarthingUnit.vue';
import InstallationLocation from './MobileService/InstallationLocation.vue';
import InternetAccess from './MobileService/InternetAccess.vue';
import Wallbox from './MobileService/Wallbox.vue';
import CableManagement from './MobileService/CableManagement.vue';
import HAK from './MobileService/HAK.vue';
import Inverter from './MobileService/Inverter.vue';
import ElectricMeter from './MobileService/ElectricMeter.vue';

/**
 * Cards of the tab Service (see feature page projekt-protokolle). In the block
 * project-service-report-data each card is saved on its own (`saveCard`); the deprecated mobile
 * layout imports this view without it and saves the whole project.
 */
export default {
  name: 'MobileProjectsServiceReport',
  components: {
    HAK,
    BrickAndSubstructure,
    SolarPanels,
    CableManagement,
    Inverter,
    ElectricMeter,
    Misc,
    Wallbox,
    InternetAccess,
    EarthingUnit,
    InstallationLocation,
  },
  mixins: [ReportCardsMixin],
  props: {
    project: { type: Object },
  },
  data() {
    return {
      reportPath: 'serviceReport',
      cards: {
        brickAndUkAssemblyType: {
          name: 'brickAndUkAssemblyType',
          fields: ['brickAndUkAssemblyType'],
          navigateTo: this.goToCard,
          successor: 'serviceBrickCoverWidthAttachments',
          predecessor: null,
          opened: false,
          completed: this.completedState,
        },
        serviceBrickCoverWidthAttachments: {
          name: 'serviceBrickCoverWidthAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceCorrectBrickHandlingAttachments',
          predecessor: 'brickAndUkAssemblyType',
          opened: false,
          completed: this.completedState,
        },
        serviceCorrectBrickHandlingAttachments: {
          name: 'serviceCorrectBrickHandlingAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'brickAndUkA2State',
          predecessor: 'serviceBrickCoverWidthAttachments',
          opened: false,
          completed: this.completedState,
        },
        brickAndUkA2State: {
          name: 'brickAndUkA2State',
          fields: ['brickAndUkA2State'],
          navigateTo: this.goToCard,
          successor: 'brickAndUkBState',
          predecessor: 'serviceCorrectBrickHandlingAttachments',
          opened: false,
          completed: this.completedState,
        },
        brickAndUkBState: {
          name: 'brickAndUkBState',
          fields: ['brickAndUkBState'],
          navigateTo: this.goToCard,
          successor: 'serviceBrickAndSubstructureAttachments',
          predecessor: 'brickAndUkA2State',
          opened: false,
          completed: this.completedState,
        },
        serviceBrickAndSubstructureAttachments: {
          name: 'serviceBrickAndSubstructureAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceCableAndPlugAttachedToRailStateAttachments',
          predecessor: 'brickAndUkBState',
          opened: false,
          completed: this.completedState,
        },
        serviceCableAndPlugAttachedToRailStateAttachments: {
          name: 'serviceCableAndPlugAttachedToRailStateAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'railsEarthed',
          predecessor: 'serviceBrickAndSubstructureAttachments',
          opened: false,
          completed: this.completedState,
        },
        railsEarthed: {
          name: 'railsEarthed',
          fields: ['railsEarthed'],
          navigateTo: this.goToCard,
          successor: 'serviceCorrectCableInputAttachments',
          predecessor: 'serviceCableAndPlugAttachedToRailStateAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceCorrectCableInputAttachments: {
          name: 'serviceCorrectCableInputAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceRailOverlappingTerminationFittingAttachments',
          predecessor: 'railsEarthed',
          opened: false,
          completed: this.completedState,
        },
        serviceRailOverlappingTerminationFittingAttachments: {
          name: 'serviceRailOverlappingTerminationFittingAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceProtectedUnderBrickCableRoutingAttachments',
          predecessor: 'serviceCorrectCableInputAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceProtectedUnderBrickCableRoutingAttachments: {
          name: 'serviceProtectedUnderBrickCableRoutingAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceBrickAndSubstructureOptionalAttachments',
          predecessor: 'serviceRailOverlappingTerminationFittingAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceBrickAndSubstructureOptionalAttachments: {
          name: 'serviceBrickAndSubstructureOptionalAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'brickAndUkOptionalNotes',
          predecessor: 'serviceProtectedUnderBrickCableRoutingAttachments',
          opened: false,
          completed: this.completedState,
        },
        brickAndUkOptionalNotes: {
          name: 'brickAndUkOptionalNotes',
          fields: ['brickAndUkOptionalNotes'],
          navigateTo: this.goToCard,
          successor: 'serviceStringPlanAttachments',
          predecessor: 'serviceBrickAndSubstructureOptionalAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceStringPlanAttachments: {
          name: 'serviceStringPlanAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'stringPlanAvailableState',
          predecessor: 'brickAndUkOptionalNotes',
          opened: false,
          completed: this.completedState,
        },
        stringPlanAvailableState: {
          name: 'stringPlanAvailableState',
          fields: ['stringPlanAvailableState'],
          navigateTo: this.goToCard,
          successor: 'serviceAllPanelsVisibleAttachments',
          predecessor: 'serviceStringPlanAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceAllPanelsVisibleAttachments: {
          name: 'serviceAllPanelsVisibleAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceClampAreaAttachments',
          predecessor: 'stringPlanAvailableState',
          opened: false,
          completed: this.completedState,
        },
        serviceClampAreaAttachments: {
          name: 'serviceClampAreaAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceTrayfDistanceAttachments',
          predecessor: 'serviceAllPanelsVisibleAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceTrayfDistanceAttachments: {
          name: 'serviceTrayfDistanceAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceRailOverlapAttachments',
          predecessor: 'serviceClampAreaAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceRailOverlapAttachments: {
          name: 'serviceRailOverlapAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'servicePanelBottomViewAttachments',
          predecessor: 'serviceTrayfDistanceAttachments',
          opened: false,
          completed: this.completedState,
        },
        servicePanelBottomViewAttachments: {
          name: 'servicePanelBottomViewAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'solarModuleTypePlateAttachments',
          predecessor: 'serviceRailOverlapAttachments',
          opened: false,
          completed: this.completedState,
        },
        solarModuleTypePlateAttachments: {
          name: 'solarModuleTypePlateAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceSolarPanelsOptionalAttachments',
          predecessor: 'servicePanelBottomViewAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceSolarPanelsOptionalAttachments: {
          name: 'serviceSolarPanelsOptionalAttachments',
          fields: ['solarPaneldOptionalNotes'],
          navigateTo: this.goToCard,
          successor: 'cableManagementC2State',
          predecessor: 'solarModuleTypePlateAttachments',
          opened: false,
          completed: this.completedState,
        },

        /** Cable Management */
        cableManagementC2State: {
          name: 'cableManagementC2State',
          fields: ['cableManagementC2State'],
          navigateTo: this.goToCard,
          successor: 'serviceCableManagementAttachments',
          predecessor: 'serviceSolarPanelsOptionalAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceCableManagementAttachments: {
          name: 'serviceCableManagementAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceCableAlongFacadeAttachments',
          predecessor: 'cableManagementC2State',
          opened: false,
          completed: this.completedState,
        },
        serviceCableAlongFacadeAttachments: {
          name: 'serviceCableAlongFacadeAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'cableManagementOptional',
          predecessor: 'serviceCableManagementAttachments',
          opened: false,
          completed: this.completedState,
        },
        cableManagementOptional: {
          name: 'cableManagementOptional',
          fields: ['cableManagementOptionalNotes'],
          navigateTo: this.goToCard,
          successor: 'hakLocationState',
          predecessor: 'serviceCableAlongFacadeAttachments',
          opened: false,
          completed: this.completedState,
        },
        /** HAK */
        hakLocationState: {
          name: 'hakLocationState',
          fields: ['hakLocationState'],
          navigateTo: this.goToCard,
          successor: 'hakLockedState',
          predecessor: 'cableManagementOptional',
          opened: false,
          completed: this.completedState,
        },
        hakLockedState: {
          name: 'hakLockedState',
          fields: ['hakLockedState'],
          navigateTo: this.goToCard,
          successor: 'hakToZsDistance',
          predecessor: 'hakLocationState',
          opened: false,
          completed: this.completedState,
        },
        hakToZsDistance: {
          name: 'hakToZsDistance',
          fields: ['hakToZsDistance'],
          navigateTo: this.goToCard,
          successor: 'hakAndZsSameRoomState',
          predecessor: 'hakLockedState',
          opened: false,
          completed: this.completedState,
        },
        hakAndZsSameRoomState: {
          name: 'hakAndZsSameRoomState',
          fields: ['hakAndZsSameRoomState'],
          navigateTo: this.goToCard,
          successor: 'serviceHakAttachments',
          predecessor: 'hakToZsDistance',
          opened: false,
          completed: this.completedState,
        },
        serviceHakAttachments: {
          name: 'serviceHakAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceHakAndZsSameRoomAttachments',
          predecessor: 'hakAndZsSameRoomState',
          opened: false,
          completed: this.completedState,
        },
        serviceHakAndZsSameRoomAttachments: {
          name: 'serviceHakAndZsSameRoomAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'zsLocationState',
          predecessor: 'serviceHakAttachments',
          opened: false,
          completed: this.completedState,
        },
        /** Electric Meter */
        zsLocationState: {
          name: 'zsLocationState',
          fields: ['zsLocationState'],
          navigateTo: this.goToCard,
          successor: 'zsWithCoverAttachments',
          predecessor: 'serviceHakAndZsSameRoomAttachments',
          opened: false,
          completed: this.completedState,
        },
        zsWithCoverAttachments: {
          name: 'zsWithCoverAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'zsWithoutCoverAttachments',
          predecessor: 'zsLocationState',
          opened: false,
          completed: this.completedState,
        },
        zsWithoutCoverAttachments: {
          name: 'zsWithoutCoverAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceZsSerialNumberAttachments',
          predecessor: 'zsWithCoverAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceZsSerialNumberAttachments: {
          name: 'serviceZsSerialNumberAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceZsPostCounterAreaAttachments',
          predecessor: 'zsWithoutCoverAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceZsPostCounterAreaAttachments: {
          name: 'serviceZsPostCounterAreaAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceZsPreCounterAreaAttachments',
          predecessor: 'serviceZsSerialNumberAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceZsPreCounterAreaAttachments: {
          name: 'serviceZsPreCounterAreaAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceZsDistributionAreaAttachments',
          predecessor: 'serviceZsPostCounterAreaAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceZsDistributionAreaAttachments: {
          name: 'serviceZsDistributionAreaAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'additionalSubDistributionState',
          predecessor: 'serviceZsPreCounterAreaAttachments',
          opened: false,
          completed: this.completedState,
        },
        additionalSubDistributionState: {
          name: 'additionalSubDistributionState',
          fields: ['additionalSubDistributionState'],
          navigateTo: this.goToCard,
          successor: 'electricMeterCount',
          predecessor: 'serviceZsDistributionAreaAttachments',
          opened: false,
          completed: this.completedState,
        },
        /** Inverter */
        electricMeterCount: {
          name: 'electricMeterCount',
          fields: ['electricMeterCount'],
          navigateTo: this.goToCard,
          successor: 'electricMeterList',
          predecessor: 'additionalSubDistributionState',
          opened: false,
          completed: this.completedState,
        },
        electricMeterList: {
          name: 'electricMeterList',
          fields: ['electricMeterList'],
          navigateTo: this.goToCard,
          successor: 'intermediateMeterRequestedState',
          predecessor: 'electricMeterCount',
          opened: false,
          completed: this.completedState,
        },
        intermediateMeterRequestedState: {
          name: 'intermediateMeterRequestedState',
          fields: ['intermediateMeterRequestedState'],
          navigateTo: this.goToCard,
          successor: 'meterCombinationRequestedState',
          predecessor: 'electricMeterList',
          opened: false,
          completed: this.completedState,
        },
        meterCombinationRequestedState: {
          name: 'meterCombinationRequestedState',
          fields: ['meterCombinationRequestedState'],
          navigateTo: this.goToCard,
          successor: 'disassembledMetersOnSiteState',
          predecessor: 'intermediateMeterRequestedState',
          opened: false,
          completed: this.completedState,
        },
        disassembledMetersOnSiteState: {
          name: 'disassembledMetersOnSiteState',
          fields: ['disassembledMetersOnSiteState'],
          navigateTo: this.goToCard,
          successor: 'serviceDisassembledMetersAttachments',
          predecessor: 'meterCombinationRequestedState',
          opened: false,
          completed: this.completedState,
        },
        serviceDisassembledMetersAttachments: {
          name: 'serviceDisassembledMetersAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'meterCascadeRequestedState',
          predecessor: 'disassembledMetersOnSiteState',
          opened: false,
          completed: this.completedState,
        },
        meterCascadeRequestedState: {
          name: 'meterCascadeRequestedState',
          fields: ['meterCascadeRequestedState'],
          navigateTo: this.goToCard,
          successor: 'serviceMainElectricMeterAttachments',
          predecessor: 'serviceDisassembledMetersAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceMainElectricMeterAttachments: {
          name: 'serviceMainElectricMeterAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceSeconaryElectricMeterAttachments',
          predecessor: 'meterCascadeRequestedState',
          opened: false,
          completed: this.completedState,
        },
        serviceSeconaryElectricMeterAttachments: {
          name: 'serviceSeconaryElectricMeterAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'installationLocationWithInverterAndMateboxState',
          predecessor: 'serviceMainElectricMeterAttachments',
          opened: false,
          completed: this.completedState,
        },
        /** Installation Location */
        installationLocationWithInverterAndMateboxState: {
          name: 'installationLocationWithInverterAndMateboxState',
          fields: ['installationLocationWithInverterAndMateboxState'],
          navigateTo: this.goToCard,
          successor: 'serviceSecondaryInstallationLocationAttachments',
          predecessor: 'serviceSeconaryElectricMeterAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceSecondaryInstallationLocationAttachments: {
          name: 'serviceSecondaryInstallationLocationAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'cablePathDistance',
          predecessor: 'installationLocationWithInverterAndMateboxState',
          opened: false,
          completed: this.completedState,
        },
        cablePathDistance: {
          name: 'cablePathDistance',
          fields: ['cablePathDistance'],
          navigateTo: this.goToCard,
          successor: 'serviceCablePath360Attachments',
          predecessor: 'serviceSecondaryInstallationLocationAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceCablePath360Attachments: {
          name: 'serviceCablePath360Attachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'cableSelection',
          predecessor: 'cablePathDistance',
          opened: false,
          completed: this.completedState,
        },
        cableSelection: {
          name: 'cableSelection',
          fields: ['cableSelection'],
          navigateTo: this.goToCard,
          successor: 'serviceOpenMatebox',
          predecessor: 'serviceCablePath360Attachments',
          opened: false,
          completed: this.completedState,
        },
        serviceOpenMatebox: {
          name: 'serviceOpenMatebox',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'distanceMeasurement',
          predecessor: 'cableSelection',
          opened: false,
          completed: this.completedState,
        },
        distanceMeasurement: {
          name: 'distanceMeasurement',
          fields: ['cablePathDistance'],
          navigateTo: this.goToCard,
          successor: 'mtbxLabelSnAttachments',
          predecessor: 'serviceOpenMatebox',
          opened: false,
          completed: this.completedState,
        },
        /** Matebox Label */
        mtbxLabelSnAttachments: {
          name: 'mtbxLabelSnAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'invLabelSnAttachments',
          predecessor: 'distanceMeasurement',
          opened: false,
          completed: this.completedState,
        },
        /** Inverter Label */
        invLabelSnAttachments: {
          name: 'invLabelSnAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'batLabelSnAttachments',
          predecessor: 'mtbxLabelSnAttachments',
          opened: false,
          completed: this.completedState,
        },
        /** Battery Label */
        batLabelSnAttachments: {
          name: 'batLabelSnAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'equipotentialBusBarPresentState',
          predecessor: 'invLabelSnAttachments',
          opened: false,
          completed: this.completedState,
        },
        /** Earthing Unit */
        equipotentialBusBarPresentState: {
          name: 'equipotentialBusBarPresentState',
          fields: ['equipotentialBusBarPresentState'],
          navigateTo: this.goToCard,
          successor: 'secondaryEquipotentialBusBarPresentState',
          predecessor: 'batLabelSnAttachments',
          opened: false,
          completed: this.completedState,
        },

        secondaryEquipotentialBusBarPresentState: {
          name: 'secondaryEquipotentialBusBarPresentState',
          fields: ['secondaryEquipotentialBusBarPresentState'],
          navigateTo: this.goToCard,
          successor: 'potentialGroundRodPresentState',
          predecessor: 'equipotentialBusBarPresentState',
          opened: false,
          completed: this.completedState,
        },
        potentialGroundRodPresentState: {
          name: 'potentialGroundRodPresentState',
          fields: ['potentialGroundRodPresentState'],
          navigateTo: this.goToCard,
          successor: 'earthingSupply16mmState',
          predecessor: 'secondaryEquipotentialBusBarPresentState',
          opened: false,
          completed: this.completedState,
        },
        earthingSupply16mmState: {
          name: 'earthingSupply16mmState',
          fields: ['earthingSupply16mmState'],
          navigateTo: this.goToCard,
          successor: 'serviceEarthingAttachments',
          predecessor: 'potentialGroundRodPresentState',
          opened: false,
          completed: this.completedState,
        },
        serviceEarthingAttachments: {
          name: 'serviceEarthingAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'internetConnectionTypeState',
          predecessor: 'earthingSupply16mmState',
          opened: false,
          completed: this.completedState,
        },
        /** InternetAccess */
        internetConnectionTypeState: {
          name: 'internetConnectionTypeState',
          fields: ['internetConnectionTypeState'],
          navigateTo: this.goToCard,
          successor: 'lanConnectionPresentState',
          predecessor: 'serviceEarthingAttachments',
          opened: false,
          completed: this.completedState,
        },
        lanConnectionPresentState: {
          name: 'lanConnectionPresentState',
          fields: ['lanConnectionPresentState'],
          navigateTo: this.goToCard,
          successor: 'qcellsWallboxContractState',
          predecessor: 'internetConnectionTypeState',
          opened: false,
          completed: this.completedState,
        },
        /** Wallbox */
        qcellsWallboxContractState: {
          name: 'qcellsWallboxContractState',
          fields: ['qcellsWallboxContractState'],
          navigateTo: this.goToCard,
          successor: 'serviceWallboxLocationAttachments',
          predecessor: 'lanConnectionPresentState',
          opened: false,
          completed: this.completedState,
        },
        serviceWallboxLocationAttachments: {
          name: 'serviceWallboxLocationAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceWallboxCablePathNotes',
          predecessor: 'qcellsWallboxContractState',
          opened: false,
          completed: this.completedState,
        },
        serviceWallboxCablePathNotes: {
          name: 'serviceWallboxCablePathNotes',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceWallboxAttachments',
          predecessor: 'serviceWallboxLocationAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceWallboxAttachments: {
          name: 'serviceWallboxAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceWallboxAccessCardAttachments',
          predecessor: 'serviceWallboxCablePathNotes',
          opened: false,
          completed: this.completedState,
        },
        serviceWallboxAccessCardAttachments: {
          name: 'serviceWallboxAccessCardAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceFiLsWallboxAttachments',
          predecessor: 'serviceWallboxAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceFiLsWallboxAttachments: {
          name: 'serviceFiLsWallboxAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'briefingAndDocumentationState',
          predecessor: 'serviceWallboxAccessCardAttachments',
          opened: false,
          completed: this.completedState,
        },
        /** Misc */

        briefingAndDocumentationState: {
          name: 'briefingAndDocumentationState',
          fields: ['briefingAndDocumentationState'],
          navigateTo: this.goToCard,
          successor: 'serviceMiscOptionalAttachments',
          predecessor: 'serviceFiLsWallboxAttachments',
          opened: false,
          completed: this.completedState,
        },
        serviceMiscOptionalAttachments: {
          name: 'serviceMiscOptionalAttachments',
          fields: [],
          navigateTo: this.goToCard,
          successor: 'serviceOptionalNotes',
          predecessor: 'briefingAndDocumentationState',
          opened: false,
          completed: this.completedState,
        },
        serviceOptionalNotes: {
          name: 'serviceOptionalNotes',
          fields: ['serviceOptionalNotes'],
          navigateTo: this.goToCard,
          successor: null,
          predecessor: 'serviceMiscOptionalAttachments',
          opened: false,
          completed: this.completedState,
        },
      },
      selectedProjectAttachmentType: null,
      /** track Upload states for clearing dropzone preview */
    };
  },

  computed: {
    isFlatRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'FLAT_ROOF';
    },
    isPitchedRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'PITCHED_ROOF';
    },
  },

  methods: {
    ...mapActions(['fetchEnumValues']),

    /** The service cards have no branch targets. */
    resolveCardTarget(target) {
      return target;
    },

    toCardInput(report, fieldPaths) {
      return toServiceCardInput(report, fieldPaths);
    },
  },
  async mounted() {
    await this.fetchEnumValues('BrickAndUkAssemblyType');
  },
};
</script>

<style lang="scss" scoped>
/** accordion */
.accordion button {
  text-align: left;
  padding: 0.8em 0.5em;
}
.accordion .card,
.accordion .card-header {
  border: 0;
  border-radius: 0em;
}
.accordion .btn.btn-block {
  border: 0;
  border-radius: 0em;
  font-weight: bold;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
